import ActionTypes from "actions/ActionTypes";

const initialState = {
  data: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_BREADCRUMBS: {
      return {
        ...state,
        data: payload.data,
      };
    }
    case ActionTypes.NAVIGATE_BREADCRUMBS: {
      return {
        ...state,
        data: state.data.slice(0, payload.index + 1),
      };
    }
    default:
      return state;
  }
};
